import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeAllFirstLetters } from "../../../../../consumingApi/services/helper";
import { Button, Drawer } from "@stonelog/stonelog-design-system";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";
import { Tag as AntdTag } from "antd";
import { hubsSelector } from "../../../../../features/senninha/hubsSlice";
import {
    getServiceDetails,
    setMapWorkflow,
    setOpenDrawer
} from "../../../../../features/senninha/pinsSlice";

const DrawerCollectionHub = ({ open, setOpen, editHub, getProviderInformationData, pins = [] }) => {
    const dispatch = useDispatch();
    const { selectedHubInfos } = useSelector(hubsSelector);

    const TODAY_STR = useMemo(() => new Date().toISOString().split('T')[0], []);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    };

    const getGroupStatus = (oss) => {
        let hasExpired = false;
        let hasToday = false;

        oss.forEach(os => {
            if (os.deadline_date < TODAY_STR) hasExpired = true;
            else if (os.deadline_date === TODAY_STR) hasToday = true;
        });

        if (hasExpired) return { priority: 1, color: "#E6171E", label: "Data limite" };
        if (hasToday) return { priority: 2, color: "#F38428", label: "Data limite" };
        return { priority: 3, color: "#0057D9", label: "Data limite" };
    };

    const clientsList = useMemo(() => {
        return [...pins].sort((a, b) => {
            const statusA = getGroupStatus(a.oss).priority;
            const statusB = getGroupStatus(b.oss).priority;
            return statusA - statusB;
        });
    }, [pins, TODAY_STR]);

    const handleSelectClient = (client) => {
        const allOsIds = client.oss?.map(os => os.id_os) || [];

        dispatch(
            getServiceDetails({
                id: client.id,
                id_atendimento: client.ids_agrupados,
                provider: selectedHubInfos.children,
                servico: client.servico,
                id_os: allOsIds
            })
        );

        dispatch(setMapWorkflow('infoDrawer'));
        dispatch(setOpenDrawer(true));
    };

    const totalOsCount = useMemo(() => {
        return clientsList.reduce((total, client) => {
            return total + (client.oss?.length || 0);
        }, 0);
    }, [clientsList]);

    return (
        <Drawer.Root
            open={open}
            title={
                <Drawer.Header
                    title={capitalizeAllFirstLetters(`Coleta no polo (${totalOsCount})`)}
                    subTitle={getProviderInformationData?.razao_social}
                />
            }
            onClose={() => setOpen(false)}
        >
            <Drawer.Body>
                {clientsList.length === 0 && (<Drawer.Empty message="Sem pins de coleta no polo." />)}
                {clientsList.map((client, index) => {
                    const status = getGroupStatus(client.oss);
                    const deadline = client.oss?.[0]?.deadline_date;

                    return (
                        <Drawer.Row
                            key={`${client.documento_cliente}_${index}`}
                            style={{ cursor: 'pointer', gap: '12px' }}
                            onClick={() => handleSelectClient(client)}
                        >
                            <Drawer.RowText
                                text={capitalizeAllFirstLetters(client?.cliente_pin_coleta.toLowerCase())}
                                description={`Quantidade ID delivery: ${client.oss?.length || 0}`}
                            />
                            <Drawer.RowActions>
                                <AntdTag
                                    style={{
                                        backgroundColor: status.color,
                                        color: "#FFFFFF",
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "2px 8px",
                                        fontWeight: "600"
                                    }}
                                >
                                    {`${status.label}: ${formatDate(deadline)}`}
                                </AntdTag>
                                <GingaIcon name="chevron-right" size={24} color="#767f8d" />
                            </Drawer.RowActions>
                        </Drawer.Row>
                    );
                })}
            </Drawer.Body>
            <Drawer.Footer>
                <Button
                    type="primary"
                    onClick={() => editHub()}
                    size="large"
                    customPrefixIcon={<GingaIcon name="edit" color="white" size={21} />}
                >
                    Editar endereço do polo
                </Button>
                <Button onClick={() => setOpen(false)} size="large">
                    Fechar
                </Button>
            </Drawer.Footer>
        </Drawer.Root>
    );
};

export default DrawerCollectionHub;
